<script setup lang="ts">
import type { SchoolClassDetail } from 'src/modules/School/composables/useSchoolData';
import { schoolUserDisplayName } from 'src/modules/School/utilities/schoolUserDisplayName';

defineProps<{
  classDetail: SchoolClassDetail;
}>();
</script>

<template>
  <div class="column q-gutter-md">
    <q-card
      bordered
      class="info-card"
    >
      <q-card-section class="q-gutter-sm">
        <div class="text-overline text-primary">{{ $t('INFORMATION') }}</div>
        <div class="text-h5 text-weight-bold">{{ classDetail.name }}</div>
        <div class="text-subtitle2 text-muted">{{ classDetail.code }}</div>

        <div class="row q-col-gutter-sm q-mt-sm">
          <div class="col-12 col-sm-6">
            <div class="text-caption text-grey-6">{{ $t('SCHOOL') }}</div>
            <div class="text-body2">
              {{
                classDetail.school?.short_name ||
                classDetail.school?.full_name ||
                '-'
              }}
            </div>
          </div>
        </div>
      </q-card-section>
    </q-card>

    <q-card
      bordered
      class="info-card"
    >
      <q-card-section>
        <div class="text-h6">{{ $t('TEACHERS') }}</div>
      </q-card-section>
      <q-separator />
      <q-list class="q-pa-sm">
        <q-item
          v-for="(teacher, teacherIndex) in classDetail.teachers || []"
          :key="teacher.documentId || teacher.email || teacherIndex"
          class="teacher-row q-mb-sm"
        >
          <q-item-section>
            <q-item-label>{{ schoolUserDisplayName(teacher) }}</q-item-label>
            <q-item-label
              v-if="teacher.email"
              caption
            >
              {{ teacher.email }}
            </q-item-label>
          </q-item-section>
        </q-item>
        <q-item v-if="!(classDetail.teachers || []).length">
          <q-item-section>
            <q-item-label class="text-muted">{{
              $t('NO_DATA_AVAILIABLE')
            }}</q-item-label>
          </q-item-section>
        </q-item>
      </q-list>
    </q-card>
  </div>
</template>

<style scoped>
.info-card {
  border-radius: 12px;
}

.teacher-row {
  border: 1px solid var(--border-subtle);
  border-radius: 10px;
  background: var(--surface-card);
}
</style>
